export default "__VITE_ASSET__CnxQkGl4__";